import React, { Component } from 'react'
import FilterView from '../views/FilterView'
import ErrorBoundry from './ErrorBoundry'
import $ from 'jquery'

const $body = $('body')

class WhatsOn extends Component {

    constructor(props) {
        super(props)

        let defaultView = 'event'
        const hash = window.location.hash.replace('#', '')

        this.$body = $('body')

        if( hash === 'event' || hash === 'day') {
            defaultView = hash
        }

        this.state = {
            view: defaultView,
            subComponentDidMount: false
        }

        if(defaultView === 'event') {
            $body.removeClass('state--whatson-day').addClass('state--whatson-event');
        }
        if(defaultView === 'day') {
            $body.removeClass('state--whatson-event').addClass('state--whatson-day');
        }

    }

    changeView(view) {
        this.setState({view: view})

        if(view === 'event') {
            $body.removeClass('state--whatson-day').addClass('state--whatson-event');
        }
        if(view === 'day') {
            $body.removeClass('state--whatson-event').addClass('state--whatson-day');
        }
    }

    render() {
        return (
            <ErrorBoundry subComponentDidMount={this.state.subComponentDidMount}>
                <FilterView filterComponentHasMounted={(val)=>{this.setState({subComponentDidMount: val})}} view={this.state.view} />
            </ErrorBoundry>
        );
    }
}

export default WhatsOn;



// WEBPACK FOOTER //
// ./src/whatson/components/WhatsOn.js